import React from 'react';
import style from './stylesheets/Loader.module.css';


const Loader = () => {
    return (
        <>
            <div className={style.adjust}>
                <div className={style.loader}></div>
                <br />
                <h1>Loading ... </h1>
            </div>
        </>
    )
}

export default Loader;
